import { render, staticRenderFns } from "./ConceptItem.vue?vue&type=template&id=acb60ef0&scoped=true&"
import script from "./ConceptItem.vue?vue&type=script&lang=js&"
export * from "./ConceptItem.vue?vue&type=script&lang=js&"
import style0 from "./ConceptItem.vue?vue&type=style&index=0&id=acb60ef0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb60ef0",
  null
  
)

export default component.exports